import { createContext, ReactNode } from 'react';

export type TreeContextType = {
    expandedNodes: string[];
    activeItemIds: string[];
    toggleNode: (id: string) => void;
    defaultIcon: boolean;
    navIcon?: boolean;
};

export const TreeContext = createContext<TreeContextType>({
    expandedNodes: [],
    activeItemIds: [],
    toggleNode: () => {},
    defaultIcon: true,
    navIcon: true,
});

export type TreeProps = {
    children: ReactNode;
    activeItemIds?: string[];
    initialOpenNodes?: string[];
    className?: string;
    defaultIcon?: boolean;
    navIcon?: boolean;
    title?: ReactNode;
    titleClassName?: string;
    loading?: boolean;
};

export type TreeNodeProps = {
    id: string;
    children: ReactNode;
    disabled?: boolean;
    depth?: number;
    prefix?: ReactNode;
    suffix?: ReactNode;
    nodeClassName?: string;
};

export type IconWrapperProps = {
    icon: ReactNode;
    disabled: boolean;
};
